<template>
    <v-card width="100%" outlined elevation="1" class="text-left mt-10 mb-3">
        <v-list-item three-line>
            <v-list-item-content>
                <v-list-item-title class="headline mb-1">{{ subject }}</v-list-item-title>
                <v-list-item-subtitle>{{ content }}</v-list-item-subtitle>
            </v-list-item-content>
        </v-list-item>
    </v-card>
</template>

<script>
    export default {
        name: "ExampleDescription",
        props: {
            subject: {
                type: String,
                default: "Title",
            },
            content: {
                type: String,
                default: "",
            },
        }
    }
</script>

<style scoped>

</style>